import { noteForIndex, triggerMomentary, type InstrumentPlayerProps } from "../playerTypes";

export function OudPlayer(props: InstrumentPlayerProps) {
  const courses = props.variant.stringProfile?.courseCount ?? 6;

  return (
    <div className="instrument-ui oud-ui" data-testid="instrument-player-oud">
      <div className="oud-pegbox" aria-label="Oud pegbox">pegbox</div>
      <div className="oud-neck" aria-label="Fretless oud neck">
        <span>fretless neck</span>
      </div>
      <div className="oud-body" aria-label="Rounded oud bowl body" data-control-target="oud-courses">
        {Array.from({ length: courses }, (_, index) => {
          const noteName = noteForIndex(props.instrument.playableNotes, index);
          return (
            <button key={index} type="button" className="oud-course" aria-label={`Pluck oud course ${index + 1}`} data-testid={`oud-course-${index}`} onClick={() => triggerMomentary(props, noteName, "course_pluck", 0.7, 460)}>
              <span />
              <span />
            </button>
          );
        })}
      </div>
      <div className="instrument-control-strip">
        <button type="button" aria-label="Trigger oud tremolo" data-testid="oud-tremolo-button" onClick={() => triggerMomentary(props, "E4", "tremolo", 0.8, 520)}>
          Tremolo area
        </button>
        <button type="button" aria-label="Trigger oud microbend drag" data-control-target="oud-microbend" onClick={() => triggerMomentary(props, "D4", "micro_bend", 0.76, 460)}>
          Microbend drag
        </button>
      </div>
      <p className="instrument-note">Iraqi Oud metadata can include floating bridge, but this UI does not define the variant by bridge alone.</p>
    </div>
  );
}
